import React from "react";

export default function ButtonSpinner({ size = 16, color = "#fff", type = "circle" }) {
  if (type === "dots") {
    // Make dots larger and more visible
    const dotSize = size / 2.2;
    return (
      <span style={{ display: "inline-flex", gap: dotSize / 2, alignItems: "center", height: size }}>
        <span style={{
          width: dotSize, height: dotSize, borderRadius: "50%", background: color, opacity: 0.7,
          animation: "btn-spinner-dots 1s infinite alternate"
        }} />
        <span style={{
          width: dotSize, height: dotSize, borderRadius: "50%", background: color, opacity: 0.7,
          animation: "btn-spinner-dots 1s 0.2s infinite alternate"
        }} />
        <span style={{
          width: dotSize, height: dotSize, borderRadius: "50%", background: color, opacity: 0.7,
          animation: "btn-spinner-dots 1s 0.4s infinite alternate"
        }} />
        <style>{`
          @keyframes btn-spinner-dots {
            0% { opacity: 0.3; transform: translateY(0);}
            100% { opacity: 1; transform: translateY(-2px);}
          }
        `}</style>
      </span>
    );
  }
  // Default: circle spinner
  return (
    <span style={{
      display: "inline-block",
      width: size,
      height: size,
      border: `${Math.max(2, size / 8)}px solid ${color}33`,
      borderTop: `${Math.max(2, size / 8)}px solid ${color}`,
      borderRadius: "50%",
      animation: "btn-spinner-spin 0.7s linear infinite"
    }}>
      <style>{`
        @keyframes btn-spinner-spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </span>
  );
}